import ConfirmationModal from '../ui/ConfirmationModal';
import MailIcon from '@/assets/icons/mail-01.svg?react';
import { useTranslation } from '@/i18n';

interface PartnershipSentConfirmationModalProps {
  closeModal: () => void;
}

const PartnershipSentConfirmationModal = ({
  closeModal,
}: PartnershipSentConfirmationModalProps) => {
  const { t } = useTranslation();
  return (
    <ConfirmationModal
      closeModal={closeModal}
      title={t('receivers.modals.partnershipSentConfirmation.title')}
      message={t('receivers.modals.partnershipSentConfirmation.message')}
      icon={<MailIcon className="size-5" />}
      goBackTitle={t('receivers.modals.partnershipSentConfirmation.close')}
      goBackAction={() => {
        closeModal();
      }}
    />
  );
};

export default PartnershipSentConfirmationModal;
